// extracted by mini-css-extract-plugin
export var divider = "_f2-7";
export var itemsToggle = "_f2-8";
export var mergeModal = "_f2-1";
export var optionCard = "_f2-4";
export var radioGroup = "_f2-6";
export var radioOption = "_f2-0";
export var selected = "_f2-5";
export var shipmentOptions = "_f2-2";
export var tableOptions = "_f2-3";